<template>
  <div class="bg-[#FFFFFF]">
    <div class="w-100 bg-[#F8F8F8] border border-2 text-black p-1 rounded-t-xl font-semibold">
      Informasi Dasar
    </div>
    <div class="p-1 border border-2 rounded-b-xl h-[25rem] overflow-auto">
      <BRow class="my-2 align-self-center">
        <BCol
          cols="5"
          class="align-self-center"
        >
          Nama Lengkap
        </BCol>
        <BCol
          cols="7"
          class="text-black font-semibold d-flex align-items-center gap-[12px]"
        >
          <span>: {{ name == '' ? '-' : name }}</span>
          <span
            id="partner-info-general-verif-ktp"
            style="display: grid; place-items: center;"
            class="w-[32px] h-[32px] rounded-circle cursor-pointer"
            :style="{backgroundColor: verificationData.bgcolor}"
          >
            <img
              :src="verificationData.icon"
              width="20"
              height="20"
              alt="status-icon"
            >
          </span>
          <b-tooltip
            target="partner-info-general-verif-ktp"
            triggers="hover"
            :noninteractive="[0, 2].includes(status)"
          >
            <router-link
              class="text-[#7B7B7B]"
              :to="[1, 3].includes(status) ? `/verification-ktp/${ktpId}/file/${partnerId}` : ''"
            >
              {{ verificationData.text }}
            </router-link>
          </b-tooltip>
        </BCol>
      </BRow>
      <BRow class="my-2 align-self-center">
        <BCol
          cols="5"
          class="align-self-center"
        >
          Username
        </BCol>
        <BCol
          cols="7"
          class="text-black font-semibold"
        >
          : {{ username == '' ? '-' : username }}
        </BCol>
      </BRow>
      <BRow class="my-2 align-self-center">
        <BCol
          cols="5"
          class="align-self-center"
        >
          Jenis Kelamin
        </BCol>
        <BCol
          cols="7"
          class="text-black font-semibold"
        >
          : {{ gender == 0 ? 'Perempuan' : 'Laki-laki' }}
        </BCol>
      </BRow>
      <BRow class="my-2 align-self-center">
        <BCol
          cols="5"
          class="align-self-center"
        >
          Nomor HP
        </BCol>
        <BCol
          cols="7"
          class="text-black font-semibold d-flex align-items-center gap-[12px]"
        >
          <span>: {{ phone == '' ? '-' : `0${phone}` }}</span>
          <button
            aria-label="edit-phone-number"
            style="border: none; outline: none; min-width: 36px;"
            @click="$bvModal.show('modal-change-phone')"
          >
            <img
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/edit.svg"
              width="24"
              height="24"
              alt="edit-icon"
            >
          </button>
        </BCol>
      </BRow>
      <BRow class="my-2 align-self-center">
        <BCol
          cols="5"
          class="align-self-center"
        >
          Email
        </BCol>
        <BCol
          cols="7"
          class="text-black font-semibold d-flex align-items-center gap-[12px]"
        >
          <span>: {{ email == '' ? '-' : email }}</span>
          <!-- <button
            aria-label="edit-email"
            style="border: none; outline: none; min-width: 36px;"
            @click="$bvModal.show('modal-change-email')"
          >
            <img
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/edit.svg"
              width="24"
              height="24"
              alt="edit-icon"
            >
          </button> -->
        </BCol>
      </BRow>
      <BRow class="my-2 align-self-center">
        <BCol
          cols="5"
          class="align-self-center"
        >
          Alamat Lengkap
        </BCol>
        <BCol
          cols="7"
          class="text-black font-semibold"
        >
          : {{ address == '' ? '-' : address }}
        </BCol>
      </BRow>
    </div>
    <ModalChangePhone
      :value-phone="phone"
      @on-confirm-button="updatePhoneUser"
    />
    <ModalPIN
      id="modal-pin-change-phone"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      title="Konfirmasi Perubahan?"
      description="Mohon verifikasi identitas kamu dengan masukan PIN"
      label-confirm-button="Konfirmasi"
      label-cancel-button="Batal"
      @on-confirm-button="successVerified"
    />
  </div>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import ModalPIN from '@/views/components/modal/ModalPIN.vue'
import rejected from '../../assets/rejected.svg'
import verified from '../../assets/verified.svg'
import inprogress from '../../assets/inprogress.svg'
import unverified from '../../assets/unverified.svg'
import ModalChangePhone from './ModalChangePhone.vue'

export default {
  components: { ModalChangePhone, ModalPIN },
  props: {
    name: {
      type: String,
      default: '-',
    },
    username: {
      type: String,
      default: '-',
    },
    status: {
      type: Number,
      default: 0,
    },
    gender: {
      type: Number,
      default: 0,
    },
    phone: {
      type: String,
      default: '-',
    },
    email: {
      type: String,
      default: '-',
    },
    address: {
      type: String,
      default: '-',
    },
    partnerId: {
      type: Number,
      default: 1,
    },
    ktpId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      params: {
        user_id: Number(this.$route.params.id),
        pin: 0,
        phone_number: '',
        supporting_link: '',
      },
    }
  },
  computed: {
    verificationData() {
      switch (this.status) {
        case 3:
          return { text: 'Pengajuan Verifikasi Ditolak', bgcolor: '#FFEDED', icon: rejected }
        case 2:
          return { text: 'Terverifikasi', bgcolor: '#DCF3EB', icon: verified }
        case 1:
          return { text: 'Sedang Proses Pengajuan Verifikasi', bgcolor: '#EEf3DC', icon: inprogress }
        default:
          return { text: 'Belum Mengajukan Verifikasi', bgcolor: '#E6E6E6', icon: unverified }
      }
    },
  },
  methods: {
    updatePhoneUser(newVal) {
      this.params.phone_number = newVal.phone_number
      this.params.supporting_link = newVal.supporting_link
      this.$bvModal.show('modal-pin-change-phone')
    },
    async successVerified(newVal) {
      this.params.pin = Number(newVal)
      const url = 'auth/api/v1/admin/user/update-phone-number'
      try {
        const res = await newAxiosIns.post(url, this.params)
        this.$toast_success({ message: 'Sukses Melakukan Perubahan Nomor HP' })
        this.$emit('update-user-data')
      } catch (error) {
        this.$toast_error({ message: 'Gagal Melakukan Perubahan Nomor HP' })
      }
    },
  },
}
</script>
